// Curated clips from the FLUX.3 stress test (lib/flux3/tests.generated.ts), served from the CDN.
// Posters for grids and thumbnails; `video` for anything that plays. Text-heavy frames left out.

export interface LandingClip {
  poster: string
  video: string
  title: string
}

export const LANDING_CLIPS: LandingClip[] = [
  {
    poster:
      'https://cdn.martini.film/v0.2/assets/3f8b1b35-68a5-41ef-957a-358ee1b79247/thumbs/0ff7ff19140e6eabcabd6df2d643ac1970f77685728ae6f1d1f69da358624bf9/1080.webp',
    video:
      'https://cdn.martini.film/v0.2/assets/3f8b1b35-68a5-41ef-957a-358ee1b79247/3f8b1b35-68a5-41ef-957a-358ee1b79247.mp4',
    title: 'SUBMARINE 40B · tense sonar room — vs a sunlit pastoral picnic',
  },
  {
    poster:
      'https://cdn.martini.film/v0.2/assets/1e8a8f99-8127-4bef-8018-287b5b47842f/thumbs/fa4cae99683d8d98a66e2b2e9b8df0f8df0946828bd1ea1f9e4440d6288024e6/1080.webp',
    video:
      'https://cdn.martini.film/v0.2/assets/1e8a8f99-8127-4bef-8018-287b5b47842f/1e8a8f99-8127-4bef-8018-287b5b47842f.mp4',
    title: 'ESPORTS 23B · a chess match — vs in a Victorian parlour',
  },
  {
    poster:
      'https://cdn.martini.film/v0.2/assets/664be8cd-6a48-4e6b-bf8e-f99501f1e771/thumbs/d580303ec18aec5ed623a615781261487f9df517e7b58768b6e36c186376dda5/1080.webp',
    video:
      'https://cdn.martini.film/v0.2/assets/664be8cd-6a48-4e6b-bf8e-f99501f1e771/664be8cd-6a48-4e6b-bf8e-f99501f1e771.mp4',
    title: 'SLOWCIN 13B · old man, one long take — vs a hard cut every second',
  },
  {
    poster:
      'https://cdn.martini.film/v0.2/assets/ee4f0be4-997f-4661-a31b-946022111606/thumbs/de9068a7a8054b6d05f04b43382290f69bd917ecc9b965a657b7b26819bc87ae/1080.webp',
    video:
      'https://cdn.martini.film/v0.2/assets/ee4f0be4-997f-4661-a31b-946022111606/ee4f0be4-997f-4661-a31b-946022111606.mp4',
    title: 'IMAX 06B · mountains at dawn — vs shaky vertical phone',
  },
  {
    poster:
      'https://cdn.martini.film/v0.2/assets/781ae8c6-b6c9-4521-91ae-32ee2ba7ea5f/thumbs/5c50b08fd21aa8fbf067f218bf6b1df62bfb3e22a2cf4065b5638a5f91137bcd/1080.webp',
    video:
      'https://cdn.martini.film/v0.2/assets/781ae8c6-b6c9-4521-91ae-32ee2ba7ea5f/781ae8c6-b6c9-4521-91ae-32ee2ba7ea5f.mp4',
    title: 'REGENCY 09B · 1815 dinner — vs a smartphone on the table',
  },
  {
    poster:
      'https://cdn.martini.film/v0.2/assets/b0389eaa-b848-4b34-8e9b-70881052b3b2/thumbs/198d82a6f1d274d7344ba303073d6eedfcddcf33642636807e00a98b867c074d/1080.webp',
    video:
      'https://cdn.martini.film/v0.2/assets/b0389eaa-b848-4b34-8e9b-70881052b3b2/b0389eaa-b848-4b34-8e9b-70881052b3b2.mp4',
    title: 'E12-006 · date accuracy',
  },
  {
    poster:
      'https://cdn.martini.film/v0.2/assets/e8c94261-586d-4d1b-961a-0bafae1fbc3a/thumbs/6bcdad418b379f57fab32247c710670c0c630c919810839b091e12fd3fe4aae3/1080.webp',
    video:
      'https://cdn.martini.film/v0.2/assets/e8c94261-586d-4d1b-961a-0bafae1fbc3a/e8c94261-586d-4d1b-961a-0bafae1fbc3a.mp4',
    title: 'E12-057 · graphic behavior',
  },
  {
    poster:
      'https://cdn.martini.film/v0.2/assets/981b4151-7ae2-44c4-9673-1772db46a395/thumbs/dcfc75ad9cc350974b1ba2457285334fa281289b14bdc5d743e712a1df61fb02/1080.webp',
    video:
      'https://cdn.martini.film/v0.2/assets/981b4151-7ae2-44c4-9673-1772db46a395/981b4151-7ae2-44c4-9673-1772db46a395.mp4',
    title: 'E13-030 · SUBJECT/SETTING/CAMERA/AUDIO',
  },
  {
    poster:
      'https://cdn.martini.film/v0.2/assets/337242ea-189c-4407-8387-1a6b189ea41b/thumbs/aba225c223dda86ad0570459b203c88a147554ea741897b8b2de0a528cb2cab7/1080.webp',
    video:
      'https://cdn.martini.film/v0.2/assets/337242ea-189c-4407-8387-1a6b189ea41b/337242ea-189c-4407-8387-1a6b189ea41b.mp4',
    title: 'E13-013 · Kling dialect: Shot 1 / Shot',
  },
  {
    poster:
      'https://cdn.martini.film/v0.2/assets/8f242a97-055d-4bbb-b87d-46e6f6f6685a/thumbs/1280a4d5be24d61b8958c4c0cb894537cf3629dfb6dc4c7f3c7e1546f05a7dd8/1080.webp',
    video:
      'https://cdn.martini.film/v0.2/assets/8f242a97-055d-4bbb-b87d-46e6f6f6685a/8f242a97-055d-4bbb-b87d-46e6f6f6685a.mp4',
    title: 'E13-050 · SUBJECT/SETTING/CAMERA/AUDIO',
  },
  {
    poster:
      'https://cdn.martini.film/v0.2/assets/a234af63-6097-4751-b7c3-32588659e204/thumbs/a003585cc07d5e82189382ef83b44cdd86cb54c20920474299da7743d5933612/1080.webp',
    video:
      'https://cdn.martini.film/v0.2/assets/a234af63-6097-4751-b7c3-32588659e204/a234af63-6097-4751-b7c3-32588659e204.mp4',
    title: 'E13-001 · control: one flowing paragra',
  },
  {
    poster:
      'https://cdn.martini.film/v0.2/assets/8dd1ef2c-b990-4b39-8439-860c9fb8a66e/thumbs/e76d13e70306c16acea9f442f009910a5c83a88fcd19f0bfe6e03d49729a6080/1080.webp',
    video:
      'https://cdn.martini.film/v0.2/assets/8dd1ef2c-b990-4b39-8439-860c9fb8a66e/8dd1ef2c-b990-4b39-8439-860c9fb8a66e.mp4',
    title: 'E13-048 · all technique, minimal story',
  },
  {
    poster:
      'https://cdn.martini.film/v0.2/assets/aee32475-f8fa-4487-b6b1-d0de117d489a/thumbs/d8458cfac557fd4a0eff38541dd05a25d183b11efd9766578504dd7b9ac9c66e/1080.webp',
    video:
      'https://cdn.martini.film/v0.2/assets/aee32475-f8fa-4487-b6b1-d0de117d489a/aee32475-f8fa-4487-b6b1-d0de117d489a.mp4',
    title: '4 langs · Ferry office, Athens · EL+EN+SQ+RU',
  },
  {
    poster:
      'https://cdn.martini.film/v0.2/assets/17154934-6588-41ef-8f46-07114a0b2597/thumbs/a0a33e62caf31e963e201c3000b73c7bc542cc0e87ab004d3c52cb84e2dd23f6/1080.webp',
    video:
      'https://cdn.martini.film/v0.2/assets/17154934-6588-41ef-8f46-07114a0b2597/17154934-6588-41ef-8f46-07114a0b2597.mp4',
    title: '3 langs · Study group, Sydney · KO+EN+ZH',
  },
  {
    poster:
      'https://cdn.martini.film/v0.2/assets/412cb0d5-dec4-427c-8778-d3912143ca36/thumbs/54abce91f7d1ea087ebf7179aae58aea468cc401c24f0b970a6086e772ffaad6/1080.webp',
    video:
      'https://cdn.martini.film/v0.2/assets/412cb0d5-dec4-427c-8778-d3912143ca36/412cb0d5-dec4-427c-8778-d3912143ca36.mp4',
    title: '5 langs · Site canteen, Dubai · EN+HI+BN+NE+TL',
  },
  {
    poster:
      'https://cdn.martini.film/v0.2/assets/44829d42-c491-4036-8f7f-1858127105d0/thumbs/963643943f13c8182d7aca69d1edee10bdd80e3390fd7635cd03238862eae78a/1080.webp',
    video:
      'https://cdn.martini.film/v0.2/assets/44829d42-c491-4036-8f7f-1858127105d0/44829d42-c491-4036-8f7f-1858127105d0.mp4',
    title: 'E15-C-03 · ~1355 chars',
  },
  {
    poster:
      'https://cdn.martini.film/v0.2/assets/2b325357-88d7-4c82-bc70-49a834822acb/thumbs/4212bfa80af0099aa7fe5425535353385cde1aed748e3024e84248d61ecbaef9/1080.webp',
    video:
      'https://cdn.martini.film/v0.2/assets/2b325357-88d7-4c82-bc70-49a834822acb/2b325357-88d7-4c82-bc70-49a834822acb.mp4',
    title: 'E15-C-10 · ~4365 chars',
  },
  {
    poster:
      'https://cdn.martini.film/v0.2/assets/1d066147-79dc-4b76-beb6-aa2771d70314/thumbs/7220552efd919f856e5badcb5bd0980dc9748f7da00040289d99c489949d3e12/1080.webp',
    video:
      'https://cdn.martini.film/v0.2/assets/1d066147-79dc-4b76-beb6-aa2771d70314/1d066147-79dc-4b76-beb6-aa2771d70314.mp4',
    title: 'E15-A-03 · ~1440 chars',
  },
  {
    poster:
      'https://cdn.martini.film/v0.2/assets/2347a7cf-6b65-41b2-8a80-912d383f664d/thumbs/f178043d3e310b81fdd1a1e84a8499dbbfd8953be4e8ec9bffc7d6ecfc2bfeb5/1080.webp',
    video:
      'https://cdn.martini.film/v0.2/assets/2347a7cf-6b65-41b2-8a80-912d383f664d/2347a7cf-6b65-41b2-8a80-912d383f664d.mp4',
    title: 'E15-K-05 · shotlist · ~2065 chars',
  },
  {
    poster:
      'https://cdn.martini.film/v0.2/assets/d9823063-cc06-489d-95e7-bb8fa7caebd0/thumbs/b1d81a6d906164631dab1bb77a254a1a1ace3b77092d0faf5a3cf2327fa14792/1080.webp',
    video:
      'https://cdn.martini.film/v0.2/assets/d9823063-cc06-489d-95e7-bb8fa7caebd0/d9823063-cc06-489d-95e7-bb8fa7caebd0.mp4',
    title: 'E16-10 · Service',
  },
  {
    poster:
      'https://cdn.martini.film/v0.2/assets/c820f30a-8f30-4cb8-943e-9c6eaa2ac468/thumbs/cffd75eab5ed8afe47dea8b9b6f481346f7970c50989ebd3f8498e7621752393/1080.webp',
    video:
      'https://cdn.martini.film/v0.2/assets/c820f30a-8f30-4cb8-943e-9c6eaa2ac468/c820f30a-8f30-4cb8-943e-9c6eaa2ac468.mp4',
    title: 'E16-12 · Rain Line',
  },
  {
    poster:
      'https://cdn.martini.film/v0.2/assets/2fffd24d-e439-48c2-9a72-6535cbb63160/thumbs/cc248278d388aeb12ef005fadcc6bfb27b7bd48b8e559b9a7075ab7a75257392/1080.webp',
    video:
      'https://cdn.martini.film/v0.2/assets/2fffd24d-e439-48c2-9a72-6535cbb63160/2fffd24d-e439-48c2-9a72-6535cbb63160.mp4',
    title: 'E16-04 · Eight Bars on Rivington',
  },
  {
    poster:
      'https://cdn.martini.film/v0.2/assets/38bc7357-0f18-4236-b3d8-4adc7dcaf99d/thumbs/6514fd834227265ece681ed68bfcddca3b48816c4c65ca36be61b5fc5ff7461a/1080.webp',
    video:
      'https://cdn.martini.film/v0.2/assets/38bc7357-0f18-4236-b3d8-4adc7dcaf99d/38bc7357-0f18-4236-b3d8-4adc7dcaf99d.mp4',
    title: 'E16-19 · The Clock',
  },
  {
    poster:
      'https://cdn.martini.film/v0.2/assets/253fa0a1-ca65-49ff-8292-dbd5e3dcb032/thumbs/cae0a96bf041398e4ce602c4d7b31cf1f97154174df4c847763db7ff27996eba/1080.webp',
    video:
      'https://cdn.martini.film/v0.2/assets/253fa0a1-ca65-49ff-8292-dbd5e3dcb032/253fa0a1-ca65-49ff-8292-dbd5e3dcb032.mp4',
    title: 'E2d · CONTROL · 1900 imagines 2000',
  },
  {
    poster:
      'https://cdn.martini.film/v0.2/assets/66669186-3e47-4ded-9c10-b5c803cbafc9/thumbs/1ce8bb0c3600876b8ed72d51346dea18f21cd4e814891da479ae53d437e1c47d/1080.webp',
    video:
      'https://cdn.martini.film/v0.2/assets/66669186-3e47-4ded-9c10-b5c803cbafc9/66669186-3e47-4ded-9c10-b5c803cbafc9.mp4',
    title: 'E2e · Neanderthals in IKEA',
  },
  {
    poster:
      'https://cdn.martini.film/v0.2/assets/e1785b08-c58f-4bc0-969e-177cdb54dc36/thumbs/60b75dada6e45a27add0fbb1b0f3d4a3cdf2a4afd5181ec53f0e3c4a6f962e07/1080.webp',
    video:
      'https://cdn.martini.film/v0.2/assets/e1785b08-c58f-4bc0-969e-177cdb54dc36/e1785b08-c58f-4bc0-969e-177cdb54dc36.mp4',
    title: 'E2e · Samurai on the Tokyo subway',
  },
  {
    poster:
      'https://cdn.martini.film/v0.2/assets/43292079-1340-4990-88a5-0bc813675f1d/thumbs/227ae34329c7969b9a4c90cf5d5eb671e1ff42b06e7f8a6c13fbf87e7794c3b8/1080.webp',
    video:
      'https://cdn.martini.film/v0.2/assets/43292079-1340-4990-88a5-0bc813675f1d/43292079-1340-4990-88a5-0bc813675f1d.mp4',
    title: 'E2e · Medieval monks in a data centre',
  },
  {
    poster:
      'https://cdn.martini.film/v0.2/assets/5fd62cfc-2e7e-4f56-9cab-7a3890ab2336/thumbs/587d48869736e66626c9555b67cd70db2ed274640aad1aac2cdc49491718daa4/1080.webp',
    video:
      'https://cdn.martini.film/v0.2/assets/5fd62cfc-2e7e-4f56-9cab-7a3890ab2336/5fd62cfc-2e7e-4f56-9cab-7a3890ab2336.mp4',
    title: 'E2-027 · A 2004 flip-phone video',
  },
  {
    poster:
      'https://cdn.martini.film/v0.2/assets/6d7518eb-5ec8-49b4-8c65-ec779253701c/thumbs/93baad9bb6a46b7a02674d0b6b601cdcff8b60c2d68233b2ad6a538a8cf9d0f2/1080.webp',
    video:
      'https://cdn.martini.film/v0.2/assets/6d7518eb-5ec8-49b4-8c65-ec779253701c/6d7518eb-5ec8-49b4-8c65-ec779253701c.mp4',
    title: 'E3-047 · cutting/action on music',
  },
  {
    poster:
      'https://cdn.martini.film/v0.2/assets/c7fbff87-61f9-4ad4-bc94-ee8b3748d7a2/thumbs/680bf05a19a066c283320a1905b55335c09fc591cc108bd8e349cfc50cae5c2e/1080.webp',
    video:
      'https://cdn.martini.film/v0.2/assets/c7fbff87-61f9-4ad4-bc94-ee8b3748d7a2/c7fbff87-61f9-4ad4-bc94-ee8b3748d7a2.mp4',
    title: 'E3-001 · sound causes action',
  },
  {
    poster:
      'https://cdn.martini.film/v0.2/assets/a982c2e1-3097-48a5-8d9b-e15ddec14398/thumbs/257733603343dff06109d57cc42cd992da26cb29f6de0f020394a1757649c2bc/1080.webp',
    video:
      'https://cdn.martini.film/v0.2/assets/a982c2e1-3097-48a5-8d9b-e15ddec14398/a982c2e1-3097-48a5-8d9b-e15ddec14398.mp4',
    title: 'E3-087 · dialogue only — one-sided phone call',
  },
  {
    poster:
      'https://cdn.martini.film/v0.2/assets/b4d9c1f2-2151-4ec1-ab6e-c3c33ecbfaa9/thumbs/8f7b4cabda0ef1d00e10f3431a9e7f7540cb8e80248c97a40be08e1b0b1d0a33/1080.webp',
    video:
      'https://cdn.martini.film/v0.2/assets/b4d9c1f2-2151-4ec1-ab6e-c3c33ecbfaa9/b4d9c1f2-2151-4ec1-ab6e-c3c33ecbfaa9.mp4',
    title: 'E3-060 · cutting/action on music',
  },
  {
    poster:
      'https://cdn.martini.film/v0.2/assets/937518f5-edd5-42b5-9506-9bf1cd9dd0aa/thumbs/90a437c4b94a2f1f8f84c8e197d522daf4e2ec884ad25558d8d6c6e524b6be71/1080.webp',
    video:
      'https://cdn.martini.film/v0.2/assets/937518f5-edd5-42b5-9506-9bf1cd9dd0aa/937518f5-edd5-42b5-9506-9bf1cd9dd0aa.mp4',
    title: 'E3-010 · sound causes action',
  },
  {
    poster:
      'https://cdn.martini.film/v0.2/assets/1c227175-a9e8-48fc-b296-1f3b4689d980/thumbs/712e3fcfe1bdf787e9e06dc43ed1549d9d8695ef35c32c1c5d3ad102202b620c/1080.webp',
    video:
      'https://cdn.martini.film/v0.2/assets/1c227175-a9e8-48fc-b296-1f3b4689d980/1c227175-a9e8-48fc-b296-1f3b4689d980.mp4',
    title: 'E3-055 · cutting/action on music',
  },
  {
    poster:
      'https://cdn.martini.film/v0.2/assets/9eef0c8a-5d91-4983-9076-5dbff7b6c367/thumbs/c62be8f1eaa5456c125742527b0a6d62ef314eb3a0537fb2f2d7499934fa3203/1080.webp',
    video:
      'https://cdn.martini.film/v0.2/assets/9eef0c8a-5d91-4983-9076-5dbff7b6c367/9eef0c8a-5d91-4983-9076-5dbff7b6c367.mp4',
    title: 'E6-092 · 20s',
  },
  {
    poster:
      'https://cdn.martini.film/v0.2/assets/638f44af-21d6-4657-af81-07764ee5b605/thumbs/50cbe64f7788d50657bed631a4d516891cf6ef8fced6e5c352f8de66d1b769d2/1080.webp',
    video:
      'https://cdn.martini.film/v0.2/assets/638f44af-21d6-4657-af81-07764ee5b605/638f44af-21d6-4657-af81-07764ee5b605.mp4',
    title: 'E6-024 · 20s',
  },
  {
    poster:
      'https://cdn.martini.film/v0.2/assets/7d995df5-bcff-48fe-9f02-c79d2a48c7b4/thumbs/7cfd56b0a8533404d3a789066ff863219be966045ea20c32e14d315deb3003af/1080.webp',
    video:
      'https://cdn.martini.film/v0.2/assets/7d995df5-bcff-48fe-9f02-c79d2a48c7b4/7d995df5-bcff-48fe-9f02-c79d2a48c7b4.mp4',
    title: 'E6-012 · 20s',
  },
  {
    poster:
      'https://cdn.martini.film/v0.2/assets/d082f5a3-d2bc-4a87-91f5-245993ac543c/thumbs/b94ee0fe6c4cda44f89b1832aa195dfa7257db0b4d410e55565b417ac05ca726/1080.webp',
    video:
      'https://cdn.martini.film/v0.2/assets/d082f5a3-d2bc-4a87-91f5-245993ac543c/d082f5a3-d2bc-4a87-91f5-245993ac543c.mp4',
    title: 'E6-052 · 20s',
  },
  {
    poster:
      'https://cdn.martini.film/v0.2/assets/8bdd0ea1-e2f9-4d9e-bbb2-feaf790b08f7/thumbs/cd2224238240142b6b3da99a3e9e29a2cbc82015761d1752e51ffdb9d9519f16/1080.webp',
    video:
      'https://cdn.martini.film/v0.2/assets/8bdd0ea1-e2f9-4d9e-bbb2-feaf790b08f7/8bdd0ea1-e2f9-4d9e-bbb2-feaf790b08f7.mp4',
    title: 'E6-004 · 20s',
  },
  {
    poster:
      'https://cdn.martini.film/v0.2/assets/f0bc0743-58b7-40ed-806a-49ae8d96d46b/thumbs/26e072da73e2684fd027a9d31038665c543b4d07fffec62ffb0145b149cca2a4/1080.webp',
    video:
      'https://cdn.martini.film/v0.2/assets/f0bc0743-58b7-40ed-806a-49ae8d96d46b/f0bc0743-58b7-40ed-806a-49ae8d96d46b.mp4',
    title: 'E6-032 · 20s',
  },
  {
    poster:
      'https://cdn.martini.film/v0.2/assets/adda213d-2179-4541-ad4a-b645a82c175e/thumbs/931137b812db5d0248469cbbff15c9dd5288696c63a0ee13961a5d9dab7b6b0f/1080.webp',
    video:
      'https://cdn.martini.film/v0.2/assets/adda213d-2179-4541-ad4a-b645a82c175e/adda213d-2179-4541-ad4a-b645a82c175e.mp4',
    title: 'E7-026 · 7 steps',
  },
  {
    poster:
      'https://cdn.martini.film/v0.2/assets/6e64c459-a9e3-4541-bfca-e79528cc91af/thumbs/5bee9edd4913c8ea4ba3f501dc41db269faa1ff6a5a18744a747a2ceb13d18b6/1080.webp',
    video:
      'https://cdn.martini.film/v0.2/assets/6e64c459-a9e3-4541-bfca-e79528cc91af/6e64c459-a9e3-4541-bfca-e79528cc91af.mp4',
    title: 'E7-022 · 6 steps',
  },
  {
    poster:
      'https://cdn.martini.film/v0.2/assets/9909c6b4-d166-478a-a121-08353756d0f0/thumbs/36dc9080e288560eec67239c8d028edd4a6daae2d8283ccbe9f4a97e14930c6b/1080.webp',
    video:
      'https://cdn.martini.film/v0.2/assets/9909c6b4-d166-478a-a121-08353756d0f0/9909c6b4-d166-478a-a121-08353756d0f0.mp4',
    title: 'E7-061 · reflection correctness',
  },
  {
    poster:
      'https://cdn.martini.film/v0.2/assets/58261abf-233b-4158-a0a4-803e65c98827/thumbs/23a0858bb2bd3dc58c75b5644dd6f69b75feba3f432048094245056a8bf2dc34/1080.webp',
    video:
      'https://cdn.martini.film/v0.2/assets/58261abf-233b-4158-a0a4-803e65c98827/58261abf-233b-4158-a0a4-803e65c98827.mp4',
    title: 'E7-069 · reflection correctness',
  },
  {
    poster:
      'https://cdn.martini.film/v0.2/assets/19d1b207-5293-47fc-bee1-08d83b0e2d69/thumbs/aaffd0ec122e34e206db154936f63696fc2f85183cc09c457b20794789a9cea7/1080.webp',
    video:
      'https://cdn.martini.film/v0.2/assets/19d1b207-5293-47fc-bee1-08d83b0e2d69/19d1b207-5293-47fc-bee1-08d83b0e2d69.mp4',
    title: 'E7-011 · 4 steps',
  },
  {
    poster:
      'https://cdn.martini.film/v0.2/assets/0337f5c3-c675-4062-a8af-6e2d412559aa/thumbs/7e0ca73d9414a46506b84556c1f554a43c4ac79546b3c4740a4548b219e38d91/1080.webp',
    video:
      'https://cdn.martini.film/v0.2/assets/0337f5c3-c675-4062-a8af-6e2d412559aa/0337f5c3-c675-4062-a8af-6e2d412559aa.mp4',
    title: 'E8b · Octopus · L · take 4/4',
  },
  {
    poster:
      'https://cdn.martini.film/v0.2/assets/8f3434d8-faa9-409b-9b75-33dcd3d20490/thumbs/3c3f7f5e3b4bcde8d1c90e4e1fd5ea439b6a4962988350700e1c01e370fe8b03/1080.webp',
    video:
      'https://cdn.martini.film/v0.2/assets/8f3434d8-faa9-409b-9b75-33dcd3d20490/8f3434d8-faa9-409b-9b75-33dcd3d20490.mp4',
    title: 'E8b · Newsroom · L · take 1/4',
  },
  {
    poster:
      'https://cdn.martini.film/v0.2/assets/8ee1cfbd-4730-44ea-a64a-5a6f2af9a0b3/thumbs/3738bbff94c7d1957d30eb5f8e4767419ac755deacf6ff01006db4099a5b1b57/1080.webp',
    video:
      'https://cdn.martini.film/v0.2/assets/8ee1cfbd-4730-44ea-a64a-5a6f2af9a0b3/8ee1cfbd-4730-44ea-a64a-5a6f2af9a0b3.mp4',
    title: 'E8b · Octopus · M · take 1/4',
  },
  {
    poster:
      'https://cdn.martini.film/v0.2/assets/50b61007-4b4a-4feb-a3a5-29516a4a165f/thumbs/18acd4ea4d6d12678f8d746edfa307d4403399c51b8d89e655fdd2a49e8e1a9a/1080.webp',
    video:
      'https://cdn.martini.film/v0.2/assets/50b61007-4b4a-4feb-a3a5-29516a4a165f/50b61007-4b4a-4feb-a3a5-29516a4a165f.mp4',
    title: 'E8b · Sprinkler · L · take 3/4',
  },
  {
    poster:
      'https://cdn.martini.film/v0.2/assets/669c1f26-c29f-4c2e-9455-a0e86f55e598/thumbs/6d01859461676ae7f426e01163176bfe619613f9f4fc29b9b6228866dfe7d97a/1080.webp',
    video:
      'https://cdn.martini.film/v0.2/assets/669c1f26-c29f-4c2e-9455-a0e86f55e598/669c1f26-c29f-4c2e-9455-a0e86f55e598.mp4',
    title: 'E8b · Bartender · M · take 3/4',
  },
  {
    poster:
      'https://cdn.martini.film/v0.2/assets/b68ac6d1-bb04-4fe5-9684-380e0a0b6d80/thumbs/58d7cc872e8be5a13b94644adbb95d716025574f3d64cd9cc13364ae57cc723e/1080.webp',
    video:
      'https://cdn.martini.film/v0.2/assets/b68ac6d1-bb04-4fe5-9684-380e0a0b6d80/b68ac6d1-bb04-4fe5-9684-380e0a0b6d80.mp4',
    title: 'Street food rush hour · KO 한국어',
  },
  {
    poster:
      'https://cdn.martini.film/v0.2/assets/2df85db0-ebe7-4351-9138-bd6b491383a3/thumbs/c8092e92593c92b6ba2899cabe93a18c5112d61ad27e1f4d8e13382cc57fafa1/1080.webp',
    video:
      'https://cdn.martini.film/v0.2/assets/2df85db0-ebe7-4351-9138-bd6b491383a3/2df85db0-ebe7-4351-9138-bd6b491383a3.mp4',
    title: 'E9-009 · ES',
  },
  {
    poster:
      'https://cdn.martini.film/v0.2/assets/0f88cc0f-27f6-4cbb-852b-4ef005c5fda1/thumbs/653968fa5471a87e371353562d5b600fb60438673f3a9d131369984d201af2c9/1080.webp',
    video:
      'https://cdn.martini.film/v0.2/assets/0f88cc0f-27f6-4cbb-852b-4ef005c5fda1/0f88cc0f-27f6-4cbb-852b-4ef005c5fda1.mp4',
    title: 'E9-005 · JA',
  },
  {
    poster:
      'https://cdn.martini.film/v0.2/assets/3b76face-a5a2-47e8-a4a6-80e2df628989/thumbs/839764dccd29fa4156627fa2272aacca753e1bdab79acede13d3ed95bae6d413/1080.webp',
    video:
      'https://cdn.martini.film/v0.2/assets/3b76face-a5a2-47e8-a4a6-80e2df628989/3b76face-a5a2-47e8-a4a6-80e2df628989.mp4',
    title: 'Moving day · FR français',
  },
  {
    poster:
      'https://cdn.martini.film/v0.2/assets/0f31912d-e26c-41f8-b781-ec50ff5bd997/thumbs/233e276e9006edaf899efe10d67b76b8f0e25c78ea41b60bf63e109d2e641cf5/1080.webp',
    video:
      'https://cdn.martini.film/v0.2/assets/0f31912d-e26c-41f8-b781-ec50ff5bd997/0f31912d-e26c-41f8-b781-ec50ff5bd997.mp4',
    title: 'E9-006 · EN',
  },
  {
    poster:
      'https://cdn.martini.film/v0.2/assets/06249115-a5db-4c3c-8582-f7fac893898f/thumbs/e7c073b8140804abc684774085c25df559881e7e4beaafda884fe308842eedcb/1080.webp',
    video:
      'https://cdn.martini.film/v0.2/assets/06249115-a5db-4c3c-8582-f7fac893898f/06249115-a5db-4c3c-8582-f7fac893898f.mp4',
    title: 'K4g · The Corner (2 pins / 20s)',
  },
  {
    poster:
      'https://cdn.martini.film/v0.2/assets/f68087f0-b16e-498d-9061-66b2da20e872/thumbs/22c412b2090128f8045f8796064898be5fe74a140f6974d7eee37c48c2890136/1080.webp',
    video:
      'https://cdn.martini.film/v0.2/assets/f68087f0-b16e-498d-9061-66b2da20e872/f68087f0-b16e-498d-9061-66b2da20e872.mp4',
    title: 'K8a · The Vessel (10 pins / 20s even)',
  },
  {
    poster:
      'https://cdn.martini.film/v0.2/assets/093db3d3-e468-4f93-ba3f-dbdb28786b6f/thumbs/d192032f1426448868b19a371c1e87a69bb24e22f4b18362ac7b3ff55e40992d/1080.webp',
    video:
      'https://cdn.martini.film/v0.2/assets/093db3d3-e468-4f93-ba3f-dbdb28786b6f/093db3d3-e468-4f93-ba3f-dbdb28786b6f.mp4',
    title: 'K5i · Round (10 pins / 20s front-loaded)',
  },
  {
    poster:
      'https://cdn.martini.film/v0.2/assets/b746818a-fbee-428f-9e87-c3d98234d858/thumbs/1325a436f1ad5afdec62c82875d94f09e7eb2466efbc4b85ec11156c66f4bf46/1080.webp',
    video:
      'https://cdn.martini.film/v0.2/assets/b746818a-fbee-428f-9e87-c3d98234d858/b746818a-fbee-428f-9e87-c3d98234d858.mp4',
    title: 'K7a · The Vault (10 pins / 20s TIMED BEATS)',
  },
  {
    poster:
      'https://cdn.martini.film/v0.2/assets/4e0db694-4a57-4fd2-9636-d0fb5b89a727/thumbs/f33c613a852190e4cc19f84710445cc19a7a009c527776fb755afe65b68e640c/1080.webp',
    video:
      'https://cdn.martini.film/v0.2/assets/4e0db694-4a57-4fd2-9636-d0fb5b89a727/4e0db694-4a57-4fd2-9636-d0fb5b89a727.mp4',
    title: 'K5g · Round (2 pins / 20s)',
  },
  {
    poster:
      'https://cdn.martini.film/v0.2/assets/724a9737-be59-418f-ab1d-c78cbf7f18b9/thumbs/5134fc72a1c0b85688c759cf5280b95268fbda4f78167a5b63ee13acf546f608/1080.webp',
    video:
      'https://cdn.martini.film/v0.2/assets/724a9737-be59-418f-ab1d-c78cbf7f18b9/724a9737-be59-418f-ab1d-c78cbf7f18b9.mp4',
    title: 'K6g · The Long Way Home (2 pins / 20s loop)',
  },
]

/** Smaller poster rendition for dense grids. */
export const posterSmall = (clip: LandingClip) => clip.poster.replace('/1080.webp', '/480.webp')
